<template>
  <li @click="showMenuItems = !showMenuItems">
    <span class="expand-item">
      <span class="menu-item">
        <span class="material-symbols-outlined">
          {{ props.icon }}
        </span>
        <span>{{ props.label }}</span>
      </span>
      <span class="material-symbols-outlined">
        {{ showMenuItems ? 'expand_circle_up' : 'expand_circle_down' }}
      </span>
    </span>
    <menu
      v-if="showMenuItems"
      class="menu-items"
    >
      <li
        v-for="item in props.menuItems"
        :key="item.label"
        class="menu-item"
        @click="
          (e) => {
            item.onClick(e);
            emit('click');
          }
        "
      >
        <span>{{ item.label }}</span>
      </li>
    </menu>
  </li>
</template>

<script lang="ts" setup>
import { ref } from 'vue';

import { type MenuItem } from './DropdownMenu.vue';

const props = defineProps<{
  label: string;
  icon?: string;
  menuItems: MenuItem[];
}>();
const emit = defineEmits(['click']);

const showMenuItems = ref<boolean>(false);
</script>

<style lang="scss" scoped>
.expand-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: $spacing-md;
  &:hover,
  &:focus,
  &:active {
    font-weight: 500;
  }
}
.menu-items {
  display: grid;
  gap: $spacing-md;
}

.menu-item {
  display: flex;
  align-items: center;
  justify-content: start;
  gap: $spacing-md;
  cursor: pointer;
  &:hover,
  &:focus,
  &:active {
    font-weight: 500;
  }
}
</style>
